import { render, staticRenderFns } from "./MustKnowItem.vue?vue&type=template&id=1538af68&scoped=true&"
import script from "./MustKnowItem.vue?vue&type=script&lang=js&"
export * from "./MustKnowItem.vue?vue&type=script&lang=js&"
import style0 from "./MustKnowItem.vue?vue&type=style&index=0&id=1538af68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1538af68",
  null
  
)

export default component.exports